import json from '@/commons/json';
import axios from 'axios';

// API thao tác với self host của convert
class drivenApi {
  port = 0;

  constructor(port) {
    if (port) {
      this.port = port;
    }
  }

  getBaseUrl() {
    return `http://localhost:${this.port}`;
  }

  /**
   * Ping kiểm tra service
   * nvtoan2 03/07/2023
   */
  async ping() {
    let sucessConnect = false;
    await axios.get([this.getBaseUrl(), 'ping'].join('/')).then(res => {
      sucessConnect = true;
    })

    return sucessConnect;
  }

  /**
   * Lấy thông tin phiên bản tool hiện tại
   * nvtoan2 05/06/2023
   */
  async getToolInfo() {
    let toolInfo;
    await axios.get([this.getBaseUrl(), 'info'].join('/')).then(res => {
      if (res.status == 200) {
        toolInfo = res.data;
      }
    });

    return toolInfo;
  }

  /**
   * Lấy thông tin phiên bản tool hiện tại
   * nvtoan2 05/06/2023
   */
  async getAllServers() {
    let servers;
    await axios.get([this.getBaseUrl(), 'servers'].join('/')).then(res => {
      if (res.status == 200) {
        servers = res.data;
      }
    });

    return servers;
  }

  /**
   * Lấy thông tin phiên bản tool hiện tại
   * nvtoan2 05/06/2023
   */
  async getAllDatabases(serverName) {
    let servers,
      url = [this.getBaseUrl(), 'databases'].join('/'),
      param = `?serverName=${serverName}`;

    await axios.get(`${url}${param}`).then(res => {
      if (res.status == 200) {
        servers = res.data;
      }
    });

    return servers;
  }

  /**
   * Lấy thông tin phiên bản desktop
   * nvtoan2 05/06/2023
   */
  async getDesktopVersion(serverName, databaseName) {
    let versionInfo,
      url = [this.getBaseUrl(), 'desktop-version'].join('/'),
      param = [`?serverName=${serverName}`, `databaseName=${databaseName}`].join('&');

    await axios.get(`${url}${param}`).then(res => {
      if (res.status == 200) {
        versionInfo = res.data;
      }
    });

    return versionInfo;
  }

  /**
   * Chuyển đổi dữ liệu
   * @param {*} param
   */
  async callbackConvert(param) {
    let url = [this.getBaseUrl(), 'login-callback'].join('/'),
      paramStr = [
        `?token=${param?.token}`,
        `databaseId=${param?.databaseId}`,
        `tenantId=${param?.tenantId}`,
        `hostingConfig=${param?.hosting}`,
      ].join('&');

    await axios.get(`${url}${paramStr}`).then(res => {});
  }

  /**
   * Sửa file báo cáo
   * @param {*} fileName 
   * nvtoan2 03/07/2023
   */
  async editReport(reportFile, token, hostingConfig) {
    let url = [this.getBaseUrl(), 'report-edit'].join('/'),
    param = [`?reportFile=${reportFile}`, `token=${token}`, `hostingConfig=${hostingConfig}`].join('&');

    await axios.get(`${url}${param}`).then(res => {});
  }

}

export default new drivenApi();
